import { useEffect } from "react";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { FirstIntro } from "@/components/shell/first-intro";
import { authClient } from "@/lib/auth-client";
import { setSentryUser } from "@/lib/sentry";

interface RouterContext {
  authClient: typeof authClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  // Says whose session an error came from, by id only.
  const userId = authClient.useSession().data?.user.id;
  useEffect(() => {
    setSentryUser(userId ? { id: userId } : null);
  }, [userId]);

  return (
    <>
      <Outlet />
      <FirstIntro />
      {import.meta.env.DEV ? (
        <TanStackRouterDevtools position="bottom-right" />
      ) : null}
    </>
  );
}
